import styled from 'styled-components';

export const SelectOption = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 0;
  width: 100%;
  word-wrap: break-word;
  white-space: normal;
`;
